export const REG_INVALID_CD = 'RESP401';
export const REG_EXPIRED_CD = 'RESP402';
export const REG_REJECTED_CD = 'RESP403';
export const REG_COMPLETED_CD = 'RESP404';

export const RSVP_EXPIRED_CD = 'RESP405';
export const RSVP_INVALID_CD = 'RESP406';
export const RSVP_ALREADY_USED_CD = 'RESP407';

export const USER_ALREADY_REGISTER = 'RESP408';
export const EMAIL_ID_ALREADY_REGISTERED_CD = 'RSVP409';

export const OTP_INVALID_CD = 'RESP409';
export const OTP_EXPIRED_CD = 'RESP410';
export const CERT_ERROR_CD = 'RESP001';
export const PROD_ERROR_CD = 'RESP002';

export const USER_PROFILE_ALREADY_EXISTS_CD = 'RESP411';

export const API_SUCCESS_CD = 'RESP000';

export const CONTACT_AMEX_MSG = 'Please contact AMEX Representative for additional help and support .';
export const EMAIL_ID_ALREADY_REGISTERED_MSG = 'Unable to complete registration';
export const RSVP_EXPIRED_ADDITIONAL_MSG = `Registration link expires in 7 days and can be used once. ${CONTACT_AMEX_MSG}`;
export const OTP_INVALID_MSG = 'The code you have entered is invalid. Please double-check the code and try again.';
